import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import Modal from './Modal';
import IconError from '../public/images/error.svg';

const ErrorModal = ({ title, text, onHide, ...props }) => {
  const { basePath } = useRouter();

  return (
    <Modal
      icon={IconError}
      title={title}
      text={text}
      modalBodyProps={{
        style: {
          backgroundImage: `url(${basePath}/images/error-modal.svg)`,
        },
      }}
      okButtonProps={{
        onClick: onHide,
      }}
      onEscapeKeyDown={onHide}
      onBackdropClick={onHide}
      {...props}
    />
  );
};

ErrorModal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  onHide: PropTypes.func,
};

export default ErrorModal;
